document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-scroll-to-product]');
  if (trigger) {
    const product = document.querySelector('[data-main-product]');
    if (product) { event.preventDefault(); product.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = option.dataset.price;
  const priceEl = document.querySelector('[data-product-price]');
  if (price && priceEl) priceEl.textContent = price;
});
